<template>
  <NotificationTemplate
    :notification="notification"
    :showSubTitle="false"
    class="notification-calendar notification-time-off-impact"
  >
    <template #pic>
      <div class="notification-calendar__icon">
        <icon
          data="@icon/calendar-full.svg"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>

    <template #title>
      <p class="notification-calendar__title notification-time-off-impact__title">{{ title }}:</p>
    </template>

    <template #content>
      <div class="notification-calendar__content">
        <CalendarEventSummary
          v-for="event in notification.events"
          :key="event.id"
          :event="event"
        />
      </div>
    </template>
  </NotificationTemplate>
</template>

<script setup lang="ts">
/** Displays the grouped time-off impact roster using the notice stage supplied by the backend. */
import { computed } from "vue"

import CalendarEventSummary from "@/components/Notification/components/CalendarEventSummary.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationTimeOffImpact } from "@/models/Notification"

const props = defineProps<{
  notification: NotificationTimeOffImpact
}>()

const title = computed(() => {
  if (!props.notification.finalNotice) return "Upcoming Team Member Time Off"
  return props.notification.startsToday
    ? "Team Member Time Off Starts Today"
    : "Team Member Time Off Starts Tomorrow"
})
</script>
